import React from "react";
import HintLabel from "../HintLabel/HintLabel";
import Label from "../Label/Label";
import InputDescription from "../InputDescription/InputDescription";
import CopyToClipboard from "../CopyToClipboard/CopyToClipboard";
import "./label-field.scss";

const LabelField = ({ value, hintText, description, className, tags = [] }) => {
  const showCopyToClipboard = tags ? tags.some((tag) => tag === "copypaste") : false;

  return (
    <div className="label-field-wrapper">
      <div className="input-field label-activity">
        {!description && (
          <div className="input-field__inner-wrapper">
            <Label className={className}>{value}</Label>
          </div>
        )}
        <>
          {!description && hintText && <HintLabel>{hintText}</HintLabel>}
          {description && <InputDescription>{description}</InputDescription>}
        </>
      </div>
      {showCopyToClipboard && (
        <div className="copy-to-clipboard-container">
          <CopyToClipboard
            text={description ? description : value ? value : hintText}
          />
        </div>
      )}
    </div>
  );
};

export default LabelField;
